import { createApiHook } from '../hooks';
import { createGeoTargetingApi } from './geoTargetingApiFactory';

export const useGeoTargetingApi = createApiHook(createGeoTargetingApi);
